// removed by extract-text-webpack-plugin
module.exports = {"date":"CalendarContainer__date___3HGU-"};